import { formatDistanceToNow } from "date-fns";
import { lt, enUS } from "date-fns/locale";
import { PostComment, ReactionSummary } from "types/Post";

const COMMENT_CHAR_LIMIT = 300;

export const truncateComment = (text: string): string => {
  if (!text || text.length <= COMMENT_CHAR_LIMIT) return text;
  return text.substring(0, COMMENT_CHAR_LIMIT) + "...";
};

export const isCommentTruncated = (text: string): boolean => {
  return Boolean(text && text.length > COMMENT_CHAR_LIMIT);
};

export const formatDate = (timestamp: number, i18n: any, t: (key: string) => string): string => {
  try {
    const currentLanguage = i18n?.language || i18n?.resolvedLanguage || "en";
    const locale = currentLanguage === "lt" ? lt : enUS;
    return formatDistanceToNow(new Date(timestamp), { 
      addSuffix: true,
      locale 
    });
  } catch {
    return t("feed_recently");
  }
};

/** The comments with one comment's reactions replaced; replies are searched too. */
export const withCommentReactions = (
  comments: PostComment[],
  commentId: string,
  reactions: ReactionSummary[]
): PostComment[] =>
  comments.map((comment) => {
    if (comment.id === commentId) return { ...comment, reactions };
    if (!comment.replies?.length) return comment;
    return { ...comment, replies: withCommentReactions(comment.replies, commentId, reactions) };
  });

export { COMMENT_CHAR_LIMIT };
